import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  private http = inject(HttpClient);

  public arenaIcons = signal<any[]>([]);
  
  public getArenaMedia(arenaId: string, mediaType: number) {
    this.http.get<any[]>(environment.platformUrl+ "api/media/arena/" + arenaId + "/" + mediaType).subscribe({
      next: (response) => {
        // Sort the icons.
        const icons = response.sort((a,b) => a.ownerId.localeCompare(b.ownerId));
        this.arenaIcons.set(icons);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  public getUploadUrl(arenaId: string, fileName: string, title: string): Observable<any> {
    const payload = {
      arenaId: arenaId,
      fileName: fileName,
      title: title,
      signedUrl: ""
    };
    return this.http.post<any>(environment.platformUrl + "api/media/upload", payload);
  }

  public uploadToS3(signedUrl: string, file: File): Observable<any> {
    return this.http.put(signedUrl, file, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public deleteMedia(arenaId: string, mediaId: string): Observable<any> {
    return this.http.delete(environment.platformUrl + "api/media/arena/" + arenaId + "/" + mediaId);
  }
}
